import type { FilterModel } from '#layers/prawopl/app/pages/cms/marketing/banners/_runtime/services/BannersService';

export const useBannerStore = defineStore('wk-banners', () =>
{
    const columns = reactive<Columns>({
        visible: {},
        positions: {}
    });
    const filter = reactive(Form.create<FilterModel>({
        status: null,
        name: '',
        dateFromUtc: null,
        dateDueUtc: null,
        onlyMine: null,
        isHiddenForEditorial: null,
        sectionId: null,
        widgetId: null,
        clickCount: null,
        isPublished: null,
        isForNewsletter: null
    }));
    const pager = reactive(new Pager(1, 20, 'DateCreatedUtc', 'DESC'));

    return { columns, filter, pager };
});
